import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../../components/Layout/Header/Header";
import Footer from "../../../components/Layout/Footer/Footer";
import ScrollToTop from "../../../components/Common/ScrollTop";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import SearchModal from "../../../components/Layout/Header/SearchModal";
// Image
import footerLogo from "../../../assets/img/logo/lite-logo.png";

import QuickLinks from "../../../components/Common/QuickLinks";

import { fetchData } from "../../../utils/fetchData";
import {
  getAPIPath,
  getMenu,
  getPageTitle,
} from "../../../utils/getDomainData";
import { BlocksRenderer } from "../../../components/BlockRenderer";
import GalleryPart from "../gallery/GalleryPart";
const currentDomain = process.env.REACT_APP_SUB_DOMAIN;
const CommonInfrastructure = () => {
  const [data, setData] = useState([]);
  const [tableData, setTableData] = useState([]);
  useEffect(() => {
    fetchData(getAPIPath()?.infra_structure, setData);
    fetchData(getAPIPath()?.Infrastructure_Equipment, setTableData);
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        <title>Infrastructure – {getPageTitle()}</title>
        <meta name="description" content="" />
        <meta name="keywords" content=""></meta>
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="home"
        TopBar="enable"
        TopBarClass="topbar-area dark-primary-bg hidden-lg"
      />
      <div className="pageTopOffset">
        <SiteBreadcrumb
          pageTitle="Infra Structure"
          pageName="Infra Structure"
          breadcrumbsClass="breadcrumb-bg"
        />
        {getMenu()}

        <div id="rs-about" className="rs-about style3 pt-50 pb-50 md-pt-30">
          <div className="container">
            <div className="row">
              <div className="col md-mb-30">
                <div className="content-wrapper">
                  <div className="content-section">
                    <h3
                      style={{ marginBottom: "20px" }}
                      title={data?.data?.attributes?.Page_Heading}
                    >
                      {data?.data?.attributes?.Page_Heading}
                    </h3>
                    <BlocksRenderer
                      content={data?.data?.attributes?.Body || []}
                    />
                    {currentDomain === "ssit" && (
                      <table class="table table-striped table-bordered">
                        <thead>
                          <tr>
                            <th scope="col">Equipment</th>
                            <th scope="col"> Cost Incurred</th>
                            <th scope="col">Lab Utilization</th>
                          </tr>
                        </thead>
                        <tbody>
                          {tableData?.data?.map((obj, index) => (
                            <>
                              {console.log("testing29......", obj)}
                              <tr>
                                <td>
                                  <BlocksRenderer
                                    content={obj?.attributes?.Equipment || []}
                                  />
                                </td>
                                <td>
                                  <BlocksRenderer
                                    content={
                                      obj?.attributes?.Cost_Incurred || []
                                    }
                                  />
                                </td>
                                <td>
                                  <BlocksRenderer
                                    content={
                                      obj?.attributes?.Lab_Utilization || []
                                    }
                                  />
                                </td>
                              </tr>
                            </>
                          ))}
                        </tbody>
                      </table>
                    )}
                    <GalleryPart
                      title={""}
                      images={data.data?.attributes?.Images}
                    />
                  </div>
                </div>
              </div>
              {showQuickLinks(currentDomain) && (
                <div className="col-lg-3 pl-20 md-pl-14">
                  <div className="about-intro">
                    <QuickLinks />
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <Accredation /> */}

      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />

      {/* scrolltop-start */}
      <ScrollToTop scrollClassName="scrollup secondaryColor" />
      {/* scrolltop-end */}

      <SearchModal />
    </React.Fragment>
  );
};

export default CommonInfrastructure;
const showQuickLinks = (currentDomain) => {
  if (currentDomain === "ssit") return true;
  else return false;
};
